module.exports = __webpack_public_path__ + "static/img/firework-01.9f2d999.png";